import { createSlice } from '@reduxjs/toolkit';

/**
 * @typedef { {
 * type: string,
 * jobid: string,
 * jobtype: import('BMapsSrc/jobs/JobDefinition').JobTypeOptions,
 * state: import('BMapsSrc/jobs/JobDefinition').JobStatusOptions,
 * done: string, delivered: string, created: string, modified: string,
 * requestmeta: { [key: string]: any },
 * } } Job
 * @type { {
 * jobs: Job[],
 * status: 'unloaded' | 'loading' | 'loaded',
 * availableTypes: string[],
 * localJobState:  { [string]: { [key: string]: any } },
 * displayedCompoundJobs: string[],
 * } }
 *
 */
export const initialState = {
    jobs: [],
    status: 'unloaded',
    availableTypes: ['folding'],
    localJobState: {},
    displayedCompoundJobs: [],
    displayedScreeningJobs: [],
};

const slice = createSlice({
    name: 'jobs',
    initialState,
    reducers: {
        loadJobs: (state, action) => { state.jobs = action.payload; state.status = 'loaded'; },
        addJob: (state, action) => { state.jobs =[...state.jobs, action.payload]; },
        removeJob: (state, action) => {
            state.jobs = state.jobs.filter((job) => job.jobid !== action.payload);
            if (state.localJobState[action.payload]) {
                state.localJobState[action.payload] = undefined;
            }
        },
        setJob: (state, action) => {
            const index = state.jobs.findIndex((job) => job.jobid === action.payload.jobid);
            state.jobs[index] = action.payload;
        },
        updateLocalJobState: (state, action) => {
            const jobId = action.payload.jobid;
            state.localJobState[jobId] = {
                ...state.localJobState[jobId],
                ...action.payload,
            };
        },
        updateDisplayedCompoundJobs: (state, action) => {
            state.displayedCompoundJobs = action.payload;
        },
        updateDisplayedScreeningJobs: (state, action) => {
            state.displayedScreeningJobs = action.payload;
        },
        setJobState: (state, action) => (action.payload),
        reset: () => initialState,
    },
});

export default slice;
